import { CircularEconomyIcon } from './customRendererIcons/CircularEconomyIcon';
import { ClimateHealthIcon } from './customRendererIcons/ClimateHealthIcon';
import { EcosystemHealthIcon } from './customRendererIcons/EcosystemHealthIcon';
import { HumanHealthIcon } from './customRendererIcons/HumanHealthIcon';
import { SocialHealthIcon } from './customRendererIcons/SocialHealthIcon';

export const customRendererFacets = [
  'climate_health',
  'human_health',
  'social_health_equity',
  'circular_economy',
  'ecosystem_health',
];

export const customRendererFacetsIcons: Record<string, JSX.Element> = {
  climate_health: <ClimateHealthIcon />,
  human_health: <HumanHealthIcon />,
  social_health_equity: <SocialHealthIcon />,
  circular_economy: <CircularEconomyIcon />,
  ecosystem_health: <EcosystemHealthIcon />,
};
